// Mock campaign data matching the PitchPond Base44 app
const campaigns = [
    {
        id: "6985fda09356abfc68857dda",
        title: "FarmFresh: AI-Powered Hydroponics for Urban Manila",
        founder: "Maria Santos",
        location: "Quezon City, Manila",
        category: "Agriculture",
        type: "investment",
        featured: true,
        verified: "verified",
        description: "AI-controlled hydroponic systems that produce 10x more yield per sqm, reducing costs by 40% and delivering farm-fresh vegetables within 24 hours.",
        raised: 3250000,
        goal: 5000000,
        backers: 42,
        daysLeft: 39,
        successPrediction: 88,
        equityOffered: 12,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=600&h=400&fit=crop",
        problem: "Metro Manila faces food security challenges with 90% of vegetables imported from far provinces, leading to high prices and waste.",
        solution: "AI-controlled hydroponic systems that produce 10x more yield per sqm, reducing costs by 40% and delivering farm-fresh vegetables within 24 hours.",
        market: "₱45B urban agriculture market in Metro Manila alone. Targeting 500 restaurants and 10,000 households in Year 1.",
        traction: "₱850K in pre-orders, 12 partner restaurants, 2 operational farms producing 500kg/week.",
        team: "Founded by agricultural engineers from UP Los Baños with 15 years combined experience in vertical farming.",
        useOfFunds: "60% for scaling to 5 farms, 25% for AI system development, 15% for marketing and logistics.",
        riskDisclosure: "Agricultural ventures face weather, pest, and market demand risks. Technology may require ongoing R&D investment.",
        milestones: [
            { title: "Secure farm locations", status: "completed", amount: 500000 },
            { title: "Deploy AI monitoring system", status: "in-progress", amount: 750000 },
            { title: "Launch delivery network", status: "pending", amount: 1000000 },
            { title: "Scale to 5 locations", status: "pending", amount: 1000000 },
        ],
        updates: [
            { date: "2026-02-15", title: "Second farm operational!", content: "We're excited to announce our second hydroponic farm in Quezon City is now fully operational and producing 250kg of leafy greens per week." },
            { date: "2026-01-20", title: "AI system beta launch", content: "Our AI monitoring system is now in beta, automatically adjusting nutrient levels and lighting schedules for optimal growth." },
        ],
        successFactors: [
            "Complete pitch information",
            "Demonstrated traction",
            "Verified founder",
            "Strong market validation",
        ],
    },
    {
        id: "6985fda09356abfc68857ddb",
        title: "MedTech PH: Telemedicine for Rural Communities",
        founder: "Dr. Juan dela Cruz",
        location: "Cebu City, Philippines",
        category: "Health",
        type: "investment",
        featured: true,
        verified: "verified",
        description: "Mobile app connecting patients with licensed doctors via video consultation, with prescription delivery and diagnostic partnerships.",
        raised: 5600000,
        goal: 8000000,
        backers: 67,
        daysLeft: 23,
        successPrediction: 85,
        equityOffered: 15,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop",
        problem: "Rural communities in the Philippines lack access to quality healthcare, with many having to travel hours to reach the nearest hospital.",
        solution: "Mobile app connecting patients with licensed doctors via video consultation, with prescription delivery and diagnostic partnerships.",
        market: "₱180B Philippine healthcare market, with 40% of the population in rural areas underserved by medical facilities.",
        traction: "₱1.2M in monthly transactions, 5,000 registered patients, partnerships with 150 licensed doctors.",
        team: "Led by Dr. Juan dela Cruz with 20 years in public health, supported by a team of 8 engineers and medical professionals.",
        useOfFunds: "40% platform development, 30% doctor recruitment, 20% marketing, 10% regulatory compliance.",
        riskDisclosure: "Healthcare regulation changes may impact operations. Requires continuous compliance with FDA and DOH regulations.",
        milestones: [
            { title: "Launch iOS & Android app", status: "completed", amount: 1500000 },
            { title: "Partner with 200 doctors", status: "completed", amount: 1000000 },
            { title: "Expand to Visayas region", status: "in-progress", amount: 2000000 },
            { title: "Add diagnostic lab partnerships", status: "pending", amount: 1500000 },
        ],
        updates: [
            { date: "2026-02-28", title: "10,000 consultations milestone!", content: "We've successfully facilitated over 10,000 telemedicine consultations across rural communities in Cebu and Bohol." },
        ],
        successFactors: [
            "Complete pitch information",
            "Strong traction metrics",
            "Verified founder",
            "Regulatory compliance demonstrated",
        ],
    },
    {
        id: "6985fda09356abfc68857ddc",
        title: "EcoBottle: Biodegradable Packaging from Coconut Waste",
        founder: "Ana Reyes",
        location: "Davao City, Philippines",
        category: "Environment",
        type: "investment",
        featured: true,
        verified: "verified",
        description: "Patent-pending process converts coconut waste into biodegradable food packaging, creating circular economy.",
        raised: 2100000,
        goal: 6000000,
        backers: 38,
        daysLeft: 74,
        successPrediction: 82,
        equityOffered: 18,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&h=400&fit=crop",
        problem: "The Philippines is the world's 3rd largest ocean plastic polluter. Single-use plastics dominate food packaging with no viable alternatives at scale.",
        solution: "Patent-pending process converts coconut waste into biodegradable food packaging, creating circular economy.",
        market: "₱85B packaging industry, with strong government mandates pushing for sustainable alternatives.",
        traction: "Working prototype, 3 pilot customers including a major fast-food chain, ₱500K in LOIs.",
        team: "Chemical engineers from Ateneo de Davao with PhD research in bioplastics. 2 patents pending.",
        useOfFunds: "50% for manufacturing facility, 30% for R&D, 20% for certifications and marketing.",
        riskDisclosure: "Manufacturing scale-up risks, raw material supply chain dependencies, and competition from established packaging companies.",
        milestones: [
            { title: "Complete patent filing", status: "completed", amount: 500000 },
            { title: "Build pilot manufacturing line", status: "in-progress", amount: 2000000 },
            { title: "Secure FDA food-safe certification", status: "pending", amount: 1000000 },
            { title: "Commercial production launch", status: "pending", amount: 2500000 },
        ],
        updates: [],
        successFactors: [
            "Patent-pending technology",
            "Verified founder",
            "Environmental impact",
            "Government policy alignment",
        ],
    },
    {
        id: "6985fda09356abfc68857ddd",
        title: "CodeCamp Pilipinas: Free Coding Bootcamp for Youth",
        founder: "Rico Fernandez",
        location: "Manila, Philippines",
        category: "Education",
        type: "donation",
        featured: false,
        verified: "verified",
        description: "6-month intensive coding bootcamp offering free training to underprivileged youth aged 18-25, with job placement support.",
        raised: 1850000,
        goal: 2500000,
        backers: 234,
        daysLeft: 8,
        successPrediction: 80,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&h=400&fit=crop",
        problem: "Youth unemployment in the Philippines reaches 15%, while the IT industry has 100,000+ unfilled positions.",
        solution: "6-month intensive coding bootcamp offering free training to underprivileged youth aged 18-25, with job placement support.",
        market: "Targeting 500 students per year across 3 cities, with plans to expand to 10 cities by 2028.",
        traction: "2 cohorts graduated, 85% employment rate within 3 months, partnerships with 20 tech companies.",
        team: "Founded by former Google Philippines engineer, with 5 full-time instructors and 20 volunteer mentors.",
        useOfFunds: "45% instructor salaries, 25% equipment, 20% facility rental, 10% student stipends.",
        riskDisclosure: "Dependent on continuous funding. Job placement rates may vary based on market conditions.",
        milestones: [
            { title: "Cohort 3 enrollment", status: "completed", amount: 500000 },
            { title: "Equipment procurement", status: "completed", amount: 625000 },
            { title: "Launch Cebu campus", status: "in-progress", amount: 750000 },
            { title: "Cohort 4 preparation", status: "pending", amount: 625000 },
        ],
        updates: [
            { date: "2026-03-01", title: "Cohort 3 graduates!", content: "48 students have completed the program with 90% securing interviews within the first week." },
        ],
        successFactors: [
            "Proven employment results",
            "Verified organization",
            "Strong community support",
            "Corporate partnerships",
        ],
    },
    {
        id: "6985fda09356abfc68857dde",
        title: "Kape Lokal: Specialty Coffee Roastery & Farmer Collective",
        founder: "Bing Villanueva",
        location: "Benguet, Philippines",
        category: "Food & Beverage",
        type: "investment",
        featured: false,
        verified: "verified",
        description: "Direct-trade roastery buying beans at fair prices, roasting locally, and exporting under premium brand.",
        raised: 2800000,
        goal: 4000000,
        backers: 52,
        daysLeft: 54,
        successPrediction: 75,
        equityOffered: 20,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=600&h=400&fit=crop",
        problem: "Filipino coffee farmers receive only 10-15% of retail value while imported coffee dominates the local market.",
        solution: "Direct-trade roastery buying beans at fair prices, roasting locally, and exporting under premium brand.",
        market: "₱120B Philippine coffee market growing at 8% annually. Specialty coffee segment fastest growing at 15%.",
        traction: "₱1.5M monthly revenue, 50 partner farmers, supply to 30 cafes in Metro Manila.",
        team: "Coffee Q-Grader certified team with experience at Starbucks Philippines and global specialty roasters.",
        useOfFunds: "40% roasting facility expansion, 25% farmer cooperative support, 20% export logistics, 15% branding.",
        riskDisclosure: "Coffee price volatility, climate risks affecting harvests, and competition from established brands.",
        milestones: [
            { title: "Expand roasting capacity", status: "completed", amount: 1000000 },
            { title: "Onboard 100 farmers", status: "in-progress", amount: 1000000 },
            { title: "Launch export operations", status: "pending", amount: 1000000 },
            { title: "Open flagship cafe", status: "pending", amount: 1000000 },
        ],
        updates: [],
        successFactors: [
            "Revenue generating",
            "Verified founder",
            "Social impact focus",
            "Growing market segment",
        ],
    },
    {
        id: "6985fda09356abfc68857ddf",
        title: "SafeRide PH: Women-Only Transportation App",
        founder: "Cleo Reyes",
        location: "Makati, Philippines",
        category: "Technology",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "Women-only ride platform with female drivers, real-time tracking shared with emergency contacts, and AI safety monitoring.",
        raised: 3150000,
        goal: 7000000,
        backers: 48,
        daysLeft: 64,
        successPrediction: 78,
        equityOffered: 15,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1449965408869-ecd309f4d2ea?w=600&h=400&fit=crop",
        problem: "Women in Metro Manila face daily safety concerns during commutes, with harassment incidents severely underreported.",
        solution: "Women-only ride platform with female drivers, real-time tracking shared with emergency contacts, and AI safety monitoring.",
        market: "15M female commuters in Metro Manila. Women spend ₱3,500/month average on transportation.",
        traction: "5,000 registered riders, 200 vetted female drivers, ₱800K monthly GMV.",
        team: "Founded by former Grab operations manager with expertise in ride-hailing logistics and safety systems.",
        useOfFunds: "35% driver recruitment, 30% app development, 20% marketing, 15% safety systems.",
        riskDisclosure: "Highly competitive ride-hailing market. Regulatory requirements for TNCs may evolve.",
        milestones: [
            { title: "Launch MVP in Makati", status: "completed", amount: 1500000 },
            { title: "Scale to Metro Manila", status: "in-progress", amount: 2000000 },
            { title: "AI safety monitoring system", status: "pending", amount: 2000000 },
            { title: "Expand to Cebu & Davao", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Clear social impact",
            "Partial verification",
            "Growing user base",
            "Underserved market",
        ],
    },
    {
        id: "6985fda09356abfc68857de0",
        title: "Project Libreng Libro: Books for Every Barangay",
        founder: "Sarah Lim",
        location: "Philippines Nationwide",
        category: "Education",
        type: "donation",
        featured: false,
        verified: "verified",
        description: "Establishing mini-libraries in 100 barangays nationwide, stocked with age-appropriate books in Filipino and English.",
        raised: 890000,
        goal: 1500000,
        backers: 456,
        daysLeft: 25,
        successPrediction: 72,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=600&h=400&fit=crop",
        problem: "Only 4% of barangays in the Philippines have public libraries, leaving millions of children without access to books.",
        solution: "Establishing mini-libraries in 100 barangays nationwide, stocked with age-appropriate books in Filipino and English.",
        market: "42,000 barangays nationwide, targeting underserved communities in Mindanao and Visayas first.",
        traction: "32 mini-libraries established, 15,000 books distributed, 8,000 registered readers.",
        team: "NGO with 5 years of literacy program experience, partnered with DepEd and local government units.",
        useOfFunds: "60% book procurement, 25% library setup, 15% community librarian training.",
        riskDisclosure: "Logistics challenges in remote areas. Community engagement varies by location.",
        milestones: [
            { title: "First 50 libraries", status: "completed", amount: 500000 },
            { title: "Librarian training program", status: "in-progress", amount: 300000 },
            { title: "Next 50 libraries", status: "pending", amount: 500000 },
            { title: "Digital reading program", status: "pending", amount: 200000 },
        ],
        updates: [],
        successFactors: [
            "Proven execution track record",
            "Verified organization",
            "Strong backer community",
            "Government partnerships",
        ],
    },
    {
        id: "6985fda09356abfc68857de1",
        title: "BayaniPay: Remittance & Savings for OFWs",
        founder: "Marco Tan",
        location: "BGC, Taguig",
        category: "Fintech",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "Blockchain-powered instant remittance at 1.5% fees, with built-in goal-based savings tools and financial literacy.",
        raised: 4200000,
        goal: 10000000,
        backers: 38,
        daysLeft: 100,
        successPrediction: 81,
        equityOffered: 10,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop",
        problem: "10M Filipino OFWs send ₱250B annually in remittances, paying 5-8% in fees to traditional money transfer services.",
        solution: "Blockchain-powered instant remittance at 1.5% fees, with built-in goal-based savings tools and financial literacy.",
        market: "₱250B annual remittance market. Even 1% market share = ₱2.5B in transaction volume.",
        traction: "₱15M monthly transaction volume, 2,000 active users, BSP sandbox approval.",
        team: "Ex-PayMaya and Coins.ph engineers, with compliance team experienced in BSP regulations.",
        useOfFunds: "40% technology development, 25% regulatory compliance, 20% user acquisition, 15% operations.",
        riskDisclosure: "Regulatory uncertainty around blockchain/crypto. BSP licensing requirements may change.",
        milestones: [
            { title: "BSP sandbox approval", status: "completed", amount: 1500000 },
            { title: "Launch in UAE corridor", status: "in-progress", amount: 2500000 },
            { title: "Full BSP license application", status: "pending", amount: 3000000 },
            { title: "Expand to Saudi & HK", status: "pending", amount: 3000000 },
        ],
        updates: [],
        successFactors: [
            "Large addressable market",
            "Partial verification",
            "Regulatory progress",
            "Experienced fintech team",
        ],
    },
    {
        id: "6985fda09356abfc68857de2",
        title: "Plastic Bank Philippines: Turning Trash into Cash",
        founder: "Maria Garcia",
        location: "Coastal Communities, Philippines",
        category: "Social Enterprise",
        type: "donation",
        featured: false,
        verified: "verified",
        description: "Exchange points where families collect plastic waste for cash, digital credits, or essential goods. Plastic is recycled.",
        raised: 1650000,
        goal: 3000000,
        backers: 312,
        daysLeft: 18,
        successPrediction: 76,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=600&h=400&fit=crop",
        problem: "Coastal communities face severe plastic pollution while residents lack income opportunities.",
        solution: "Exchange points where families collect plastic waste for cash, digital credits, or essential goods. Plastic is recycled.",
        market: "350,000 tons of plastic waste generated in coastal areas annually, with growing global demand for recycled plastic.",
        traction: "15 exchange points operational, 3,000 registered collectors, 200 tons of plastic recycled.",
        team: "Environmental NGO with 8 years experience in community waste management programs.",
        useOfFunds: "50% exchange point setup, 25% collection logistics, 15% recycling partnerships, 10% community training.",
        riskDisclosure: "Dependent on recycling market prices. Community engagement requires continuous effort.",
        milestones: [
            { title: "First 15 exchange points", status: "completed", amount: 750000 },
            { title: "Mobile collection fleet", status: "in-progress", amount: 750000 },
            { title: "Recycling facility partnership", status: "pending", amount: 750000 },
            { title: "Expand to 50 communities", status: "pending", amount: 750000 },
        ],
        updates: [],
        successFactors: [
            "Proven social impact model",
            "Verified organization",
            "Strong backer support",
            "Environmental urgency",
        ],
    },
    {
        id: "6985fda09356abfc68857de3",
        title: "FitnessPH: AI Personal Training for Everyone",
        founder: "Jake Reyes",
        location: "Quezon City, Philippines",
        category: "Health",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "AI-powered fitness app with personalized workouts, nutrition plans, and form correction via phone camera. ₱199/month.",
        raised: 1900000,
        goal: 5500000,
        backers: 29,
        daysLeft: 84,
        successPrediction: 70,
        equityOffered: 12,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=400&fit=crop",
        problem: "Gym memberships are unaffordable for most Filipinos, and personal trainers cost ₱1,500-3,000 per session.",
        solution: "AI-powered fitness app with personalized workouts, nutrition plans, and form correction via phone camera. ₱199/month.",
        market: "₱45B Philippine fitness market, 60M smartphone users, less than 5% gym penetration rate.",
        traction: "8,000 downloads, 1,200 paying subscribers, 4.5★ average rating on both app stores.",
        team: "Sports science graduate and full-stack developer, with AI/ML consultant from DLSU.",
        useOfFunds: "50% AI development, 25% marketing, 15% content creation, 10% operations.",
        riskDisclosure: "Competitive fitness app market. AI accuracy requires continuous improvement and data collection.",
        milestones: [
            { title: "Launch v2.0 with AI form correction", status: "completed", amount: 1000000 },
            { title: "Reach 5,000 subscribers", status: "in-progress", amount: 1500000 },
            { title: "Add nutrition AI", status: "pending", amount: 1500000 },
            { title: "Corporate wellness partnerships", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Working product with users",
            "Partial verification",
            "Affordable price point",
            "Large potential market",
        ],
    },
    {
        id: "6985fda09356abfc68857de4",
        title: "Bamboo Housing Co-op: Affordable Eco-Homes",
        founder: "Edgar Cruz",
        location: "Laguna, Philippines",
        category: "Real Estate",
        type: "investment",
        featured: false,
        verified: "unverified",
        description: "Engineered bamboo housing that costs 40% less, builds 50% faster, and sequesters carbon. Modular eco-home designs.",
        raised: 3800000,
        goal: 12000000,
        backers: 22,
        daysLeft: 116,
        successPrediction: 68,
        equityOffered: 25,
        riskLevel: "high",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600&h=400&fit=crop",
        problem: "6.5M Filipino families lack adequate housing, with conventional construction costs rising 10% annually.",
        solution: "Engineered bamboo housing that costs 40% less, builds 50% faster, and sequesters carbon. Modular eco-home designs.",
        market: "₱1.8T housing backlog. Government targeting 1M new homes by 2028.",
        traction: "3 model homes built, structural engineering certification obtained, DPWH compliance pending.",
        team: "Civil engineer and architect team with experience in social housing projects across Luzon.",
        useOfFunds: "60% production facility, 20% certifications, 10% marketing, 10% working capital.",
        riskDisclosure: "Unverified founder. Construction regulatory approvals pending. Bamboo supply chain needs development.",
        milestones: [
            { title: "DPWH structural certification", status: "in-progress", amount: 2000000 },
            { title: "Bamboo treatment facility", status: "pending", amount: 3000000 },
            { title: "First 20-unit community", status: "pending", amount: 4000000 },
            { title: "Scale to 100 units", status: "pending", amount: 3000000 },
        ],
        updates: [],
        successFactors: [
            "Addresses housing crisis",
            "Unverified — higher risk",
            "Innovative technology",
            "Government alignment",
        ],
    },
    {
        id: "6985fda09356abfc68857de5",
        title: "Cebuano Comics Revival: Digital Publishing Platform",
        founder: "Pete Gonzales",
        location: "Cebu City, Philippines",
        category: "Creative",
        type: "donation",
        featured: false,
        verified: "partial",
        description: "Digital platform publishing Cebuano komiks, supporting local artists, and preserving cultural stories for future generations.",
        raised: 520000,
        goal: 800000,
        backers: 178,
        daysLeft: 13,
        successPrediction: 62,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1588497859490-85d1c17db960?w=600&h=400&fit=crop",
        problem: "Cebuano komiks tradition is disappearing as artists lack publishing platforms and monetization opportunities.",
        solution: "Digital platform publishing Cebuano komiks, supporting local artists, and preserving cultural stories for future generations.",
        market: "8M Cebuano speakers, growing digital comics market in SEA valued at $2.5B.",
        traction: "50 artists onboarded, 200 published stories, 15,000 monthly active readers.",
        team: "Comic artists and tech developers passionate about preserving Visayan culture.",
        useOfFunds: "40% platform development, 30% artist payments, 20% marketing, 10% operations.",
        riskDisclosure: "Content monetization model still maturing. Artist retention can be challenging.",
        milestones: [
            { title: "Launch digital platform", status: "completed", amount: 200000 },
            { title: "Onboard 100 artists", status: "in-progress", amount: 200000 },
            { title: "Monetization features", status: "pending", amount: 200000 },
            { title: "Print anthology", status: "pending", amount: 200000 },
        ],
        updates: [],
        successFactors: [
            "Cultural preservation mission",
            "Partial verification",
            "Active creator community",
            "Growing readership",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc79",
        title: "FarmConnect: Smart Agriculture for Filipino Farmers",
        founder: "Carlos Mendoza",
        location: "Pampanga, Philippines",
        category: "Agriculture",
        type: "investment",
        featured: true,
        verified: "verified",
        description: "FarmConnect is a mobile platform that directly connects farmers to restaurants, groceries, and consumers. We provide real-time crop pricing, logistics coordination, and AI-powered farming advice.",
        raised: 1450000,
        goal: 2000000,
        backers: 87,
        daysLeft: 39,
        successPrediction: 85,
        equityOffered: 15,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=600&h=400&fit=crop",
        problem: "Filipino farmers lose 30-40% of revenue to middlemen and lack access to market pricing information.",
        solution: "Mobile platform connecting farmers directly to buyers with real-time pricing and logistics coordination.",
        market: "₱1.5T Philippine agriculture sector with 10M farmers. Direct-to-consumer farming platforms growing 25% YoY.",
        traction: "₱2M monthly GMV, 500 farmers, 80 restaurant partners, 4.7★ rating.",
        team: "Agritech veterans with combined 20 years experience from IRRI and Landbank.",
        useOfFunds: "35% logistics infrastructure, 30% platform development, 20% farmer onboarding, 15% marketing.",
        riskDisclosure: "Agricultural market volatility, logistics challenges in rural areas, and competition from established middlemen networks.",
        milestones: [
            { title: "Launch in Central Luzon", status: "completed", amount: 500000 },
            { title: "Expand to 1,000 farmers", status: "in-progress", amount: 500000 },
            { title: "Launch cold chain logistics", status: "pending", amount: 500000 },
            { title: "Expand to Visayas", status: "pending", amount: 500000 },
        ],
        updates: [
            { date: "2026-02-20", title: "500 farmers onboarded!", content: "We've hit our farmer recruitment target for Central Luzon 2 months ahead of schedule." },
        ],
        successFactors: [
            "Strong traction and revenue",
            "Verified founder",
            "Clear social impact",
            "Experienced team",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7a",
        title: "EduBridge: Free Tablets for Mindanao Schools",
        founder: "Fatima Abdullah",
        location: "Davao, Philippines",
        category: "Education",
        type: "donation",
        featured: true,
        verified: "verified",
        description: "We distribute refurbished tablets preloaded with offline educational content aligned with DepEd's K-12 curriculum. Each tablet includes a solar charger for off-grid areas.",
        raised: 520000,
        goal: 800000,
        backers: 234,
        daysLeft: 55,
        successPrediction: 78,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600&h=400&fit=crop",
        problem: "60% of Mindanao schools lack computers and internet access, leaving students behind in digital literacy.",
        solution: "Refurbished tablets with offline educational content and solar chargers for off-grid schools.",
        market: "5,000+ schools in Mindanao underserved, each needing 20-50 tablets.",
        traction: "300 tablets distributed to 15 schools, 3,000 students reached, DepEd partnership secured.",
        team: "Education NGO team with 7 years experience in digital literacy programs.",
        useOfFunds: "70% tablet procurement & refurbishment, 15% content development, 10% distribution, 5% monitoring.",
        riskDisclosure: "Supply chain for refurbished tablets can be inconsistent. Off-grid areas present logistical challenges.",
        milestones: [
            { title: "First 300 tablets distributed", status: "completed", amount: 250000 },
            { title: "Content for Grades 1-6", status: "completed", amount: 150000 },
            { title: "Expand to 50 schools", status: "in-progress", amount: 250000 },
            { title: "Teacher training program", status: "pending", amount: 150000 },
        ],
        updates: [],
        successFactors: [
            "DepEd partnership",
            "Verified organization",
            "Measurable student impact",
            "Solar charging solution",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7b",
        title: "GreenRoof PH: Urban Vertical Farming",
        founder: "David Lee",
        location: "Makati, Philippines",
        category: "Environment",
        type: "investment",
        featured: true,
        verified: "verified",
        description: "We build modular vertical farms on unused rooftops of commercial buildings. Our hydroponic systems produce lettuce, herbs, and microgreens with 90% less water than traditional farming.",
        raised: 890000,
        goal: 3000000,
        backers: 45,
        daysLeft: 115,
        successPrediction: 72,
        equityOffered: 20,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&h=400&fit=crop",
        problem: "Urban areas import 90% of fresh produce, resulting in carbon emissions and food waste during transit.",
        solution: "Modular vertical farms on unused rooftops, producing fresh greens with 90% less water.",
        market: "₱30B urban fresh produce market in Metro Manila, with growing demand for locally-sourced food.",
        traction: "2 rooftop installations, producing 100kg/week, supplying 5 restaurants.",
        team: "Hydroponics engineer and commercial real estate professional with rooftop access partnerships.",
        useOfFunds: "60% rooftop installations, 20% hydroponic systems, 10% team, 10% marketing.",
        riskDisclosure: "Rooftop lease agreements, building structural requirements, and seasonal variations in production.",
        milestones: [
            { title: "First 2 rooftop farms", status: "completed", amount: 500000 },
            { title: "Scale to 10 rooftops", status: "pending", amount: 1000000 },
            { title: "Restaurant delivery network", status: "pending", amount: 750000 },
            { title: "Franchise model development", status: "pending", amount: 750000 },
        ],
        updates: [],
        successFactors: [
            "Working installations",
            "Verified founder",
            "Sustainable business model",
            "Urban food security impact",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7c",
        title: "TindahanTech: AI-Powered Sari-Sari Store Management",
        founder: "Jun Navarro",
        location: "Quezon City, Philippines",
        category: "Technology",
        type: "investment",
        featured: false,
        verified: "verified",
        description: "A simple Taglish mobile app that helps sari-sari store owners track inventory, manage utang (credit), and order supplies at wholesale prices.",
        raised: 2100000,
        goal: 5000000,
        backers: 63,
        daysLeft: 69,
        successPrediction: 82,
        equityOffered: 12,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop",
        problem: "1.3M sari-sari stores operate with pen-and-paper systems, losing money to untracked credit and inefficient inventory.",
        solution: "Taglish mobile app for inventory tracking, credit management, and wholesale ordering at better prices.",
        market: "1.3M sari-sari stores, each spending ₱5,000-50,000/month on inventory. ₱1.2T total retail sector.",
        traction: "3,000 active stores, ₱5M monthly wholesale orders processed, 92% retention rate.",
        team: "Ex-Lazada product manager and FMCG distribution expert, with tech team from Accenture Philippines.",
        useOfFunds: "40% product development, 25% partnerships with distributors, 20% field operations, 15% marketing.",
        riskDisclosure: "User adoption in low-tech environments, distribution partnership dependencies, and competition from FMCG apps.",
        milestones: [
            { title: "Launch core inventory app", status: "completed", amount: 1000000 },
            { title: "Wholesale ordering feature", status: "completed", amount: 1000000 },
            { title: "AI credit scoring", status: "in-progress", amount: 1500000 },
            { title: "Expand to Visayas", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Strong retention metrics",
            "Verified founder",
            "Massive addressable market",
            "Revenue generating",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7d",
        title: "Bahay Kubo Bamboo Homes",
        founder: "Elena Magtanggol",
        location: "Leyte, Philippines",
        category: "Real Estate",
        type: "donation",
        featured: false,
        verified: "verified",
        description: "We build typhoon-resistant bamboo homes using engineered bamboo technology. Each home costs only ₱120,000, is 3x stronger than traditional nipa huts, and can be built in 5 days.",
        raised: 780000,
        goal: 1500000,
        backers: 189,
        daysLeft: 54,
        successPrediction: 80,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=600&h=400&fit=crop",
        problem: "Typhoon-affected families in Leyte still live in temporary shelters years after disasters struck.",
        solution: "Typhoon-resistant bamboo homes that cost ₱120K, are 3x stronger than nipa huts, built in 5 days.",
        market: "4M families in typhoon-prone areas need resilient housing solutions.",
        traction: "25 homes built, 100+ families housed, featured by UN-Habitat as best practice.",
        team: "Structural engineers and community organizers with post-disaster reconstruction experience since Typhoon Yolanda.",
        useOfFunds: "80% construction materials and labor, 10% community training, 10% monitoring & evaluation.",
        riskDisclosure: "Construction depends on trained local labor availability. Bamboo supply seasonal.",
        milestones: [
            { title: "Build first 25 homes", status: "completed", amount: 500000 },
            { title: "Train local builders", status: "in-progress", amount: 250000 },
            { title: "Next 25 homes", status: "pending", amount: 500000 },
            { title: "Community resilience center", status: "pending", amount: 250000 },
        ],
        updates: [],
        successFactors: [
            "UN-Habitat recognition",
            "Verified organization",
            "Disaster recovery impact",
            "Community-driven approach",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7e",
        title: "KainNa: Filipino Cloud Kitchen Network",
        founder: "Chef Ramon Diaz",
        location: "Cebu City, Philippines",
        category: "Food & Beverage",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "A network of shared commercial kitchens where home cooks can professionalize their operations. We provide the space, equipment, packaging, and delivery integration.",
        raised: 950000,
        goal: 4000000,
        backers: 28,
        daysLeft: 130,
        successPrediction: 65,
        equityOffered: 18,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop",
        problem: "Home-based food businesses struggle with health certifications, inconsistent quality, and delivery logistics.",
        solution: "Shared commercial kitchens with equipment, packaging, health certifications, and delivery integration.",
        market: "₱800B Philippine food delivery market. 500,000+ home-based food businesses seeking professionalization.",
        traction: "1 kitchen operational, 15 resident cooks, ₱600K monthly revenue, partnered with GrabFood & Foodpanda.",
        team: "Chef with 15 years experience, partnered with commercial kitchen designer and food delivery logistics expert.",
        useOfFunds: "50% kitchen buildout (3 locations), 20% equipment, 15% marketing, 15% operations.",
        riskDisclosure: "Real estate costs, food safety compliance, and dependency on delivery platform partnerships.",
        milestones: [
            { title: "First Cebu kitchen", status: "completed", amount: 1000000 },
            { title: "Manila kitchen", status: "pending", amount: 1200000 },
            { title: "Davao kitchen", status: "pending", amount: 1000000 },
            { title: "Franchise model", status: "pending", amount: 800000 },
        ],
        updates: [],
        successFactors: [
            "Revenue generating",
            "Partial verification",
            "Delivery platform partnerships",
            "Growing food delivery market",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc7f",
        title: "HealPH: Telemedicine for Rural Barangays",
        founder: "Dr. Rosa Santiago",
        location: "Palawan, Philippines",
        category: "Health",
        type: "donation",
        featured: false,
        verified: "verified",
        description: "We deploy telemedicine kits to rural barangay health centers — each kit includes a tablet, vital signs monitor, digital stethoscope, and satellite internet for video consultations with city-based doctors.",
        raised: 340000,
        goal: 1200000,
        backers: 145,
        daysLeft: 86,
        successPrediction: 74,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=600&h=400&fit=crop",
        problem: "Only 1 doctor per 10,000 people in rural Palawan. Patients travel 4-8 hours for basic medical consultation.",
        solution: "Telemedicine kits with tablet, vital signs monitor, digital stethoscope, and satellite internet for remote consultations.",
        market: "42,000 barangay health centers nationwide, 90% without telemedicine capability.",
        traction: "10 kits deployed, 500 consultations completed, 95% patient satisfaction rate.",
        team: "Dr. Rosa Santiago, former DOH regional health officer, with health IT team from UP Manila.",
        useOfFunds: "60% telemedicine kits, 20% satellite internet, 10% health worker training, 10% monitoring.",
        riskDisclosure: "Internet connectivity in remote areas, health worker digital literacy requirements.",
        milestones: [
            { title: "Deploy 10 pilot kits", status: "completed", amount: 300000 },
            { title: "Expand to 30 barangays", status: "pending", amount: 400000 },
            { title: "Doctor volunteer network", status: "pending", amount: 250000 },
            { title: "Data analytics dashboard", status: "pending", amount: 250000 },
        ],
        updates: [],
        successFactors: [
            "Life-saving healthcare impact",
            "Verified organization",
            "DOH alignment",
            "Proven pilot results",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc80",
        title: "Alon Surf School & Eco-Resort",
        founder: "Paolo Mendez",
        location: "Siargao, Philippines",
        category: "Creative",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "A community-owned surf school and eco-resort built with sustainable materials, powered by solar energy, and employing 100% local staff. Profits are shared with the barangay.",
        raised: 1200000,
        goal: 6000000,
        backers: 38,
        daysLeft: 147,
        successPrediction: 60,
        equityOffered: 22,
        riskLevel: "high",
        image: "https://images.unsplash.com/photo-1502680390548-bdbac40e47a6?w=600&h=400&fit=crop",
        problem: "Tourism development in Siargao bypasses local communities, with profits going to outside investors.",
        solution: "Community-owned surf school and eco-resort with profit sharing, sustainable construction, and local employment.",
        market: "₱85B Philippine tourism market, Siargao visitor numbers growing 30% annually.",
        traction: "Land secured, architectural plans approved, 3 local staff hired for construction management.",
        team: "Professional surfer turned social entrepreneur, partnered with sustainable architecture firm from Manila.",
        useOfFunds: "60% construction, 15% equipment, 15% marketing, 10% community programs.",
        riskDisclosure: "Tourism industry volatility, weather/typhoon risks, construction delays, extended timeline.",
        milestones: [
            { title: "Land and permits secured", status: "completed", amount: 1000000 },
            { title: "Phase 1 construction", status: "pending", amount: 2000000 },
            { title: "Open surf school", status: "pending", amount: 1500000 },
            { title: "Complete eco-resort", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Community impact model",
            "Partial verification",
            "Growing tourism market",
            "Sustainable approach",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc81",
        title: "PesoWise: Financial Literacy App for OFWs",
        founder: "Lisa Tan",
        location: "Manila, Philippines",
        category: "Fintech",
        type: "investment",
        featured: false,
        verified: "verified",
        description: "A Taglish app that helps OFWs budget, save, and invest their remittances. Auto-splits remittance into spending, savings, and micro-investments. Includes financial literacy content.",
        raised: 1800000,
        goal: 3500000,
        backers: 72,
        daysLeft: 84,
        successPrediction: 80,
        equityOffered: 14,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=600&h=400&fit=crop",
        problem: "70% of OFW families spend all remittances within a month, with no savings or investment culture.",
        solution: "Taglish app that auto-splits remittances into spending, savings, and micro-investments with financial literacy content.",
        market: "10M OFWs sending ₱250B/year. Financial literacy apps for diaspora communities is a growing global trend.",
        traction: "15,000 downloads, 4,000 active users, ₱25M total savings facilitated, SEC sandbox participant.",
        team: "Former OFW turned fintech founder, with team from BPI and Sun Life Philippines.",
        useOfFunds: "35% product development, 25% user acquisition, 20% partnerships, 20% compliance.",
        riskDisclosure: "SEC regulatory requirements for investment features, user education needed for financial products.",
        milestones: [
            { title: "Launch budgeting features", status: "completed", amount: 500000 },
            { title: "Micro-investment integration", status: "completed", amount: 750000 },
            { title: "OFW community partnerships", status: "in-progress", amount: 750000 },
            { title: "Launch in Saudi Arabia", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Clear product-market fit",
            "Verified founder",
            "Former OFW perspective",
            "SEC sandbox participant",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc82",
        title: "Bayan Brew: Heritage Coffee Cooperative",
        founder: "Aling Minda",
        location: "Benguet, Philippines",
        category: "Social Enterprise",
        type: "donation",
        featured: false,
        verified: "partial",
        description: "A farmer-owned coffee cooperative that handles the full value chain: growing, processing, roasting, branding, and direct-to-consumer sales under the 'Bayan Brew' brand.",
        raised: 380000,
        goal: 500000,
        backers: 456,
        daysLeft: 24,
        successPrediction: 76,
        equityOffered: null,
        riskLevel: "low",
        image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&h=400&fit=crop",
        problem: "Cordillera coffee farmers earn ₱30-50/kg while retail arabica coffee sells for ₱800-1,500/kg.",
        solution: "Farmer-owned cooperative controlling the full value chain from growing to retail under their own brand.",
        market: "₱120B Philippine coffee market, rising specialty coffee culture, and growing demand for ethically-sourced beans.",
        traction: "50 member-farmers, 2 tons/month production, supplying to 10 cafes across Manila, 200+ online orders/month.",
        team: "Indigenous Ibaloi farming cooperative with 30 years of coffee cultivation experience.",
        useOfFunds: "40% processing equipment, 25% roasting facility upgrade, 20% branding & packaging, 15% training.",
        riskDisclosure: "Seasonal harvest variability, cooperative governance challenges, and competition from established brands.",
        milestones: [
            { title: "Upgrade processing equipment", status: "completed", amount: 150000 },
            { title: "Launch online store", status: "completed", amount: 100000 },
            { title: "New branding & packaging", status: "in-progress", amount: 100000 },
            { title: "Expand to supermarkets", status: "pending", amount: 150000 },
        ],
        updates: [],
        successFactors: [
            "Strong community support",
            "Partial verification",
            "Heritage product story",
            "Growing local backer base",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc83",
        title: "ReefGuard: Coral Reef Restoration Drones",
        founder: "Dr. Miguel Santos",
        location: "Puerto Princesa, Philippines",
        category: "Environment",
        type: "investment",
        featured: false,
        verified: "partial",
        description: "Underwater drones that plant coral fragments 10x faster than divers. Our AI system identifies optimal planting locations based on water temperature, currents, and existing reef health.",
        raised: 680000,
        goal: 4500000,
        backers: 31,
        daysLeft: 178,
        successPrediction: 55,
        equityOffered: 20,
        riskLevel: "high",
        image: "https://images.unsplash.com/photo-1546026423-cc4642628d2b?w=600&h=400&fit=crop",
        problem: "Philippines has lost 50% of its coral reefs, threatening ₱120B annual marine biodiversity tourism and fishing livelihoods.",
        solution: "Underwater drones using AI to identify and plant coral fragments 10x faster than manual diving methods.",
        market: "₱45B global coral restoration market, with Philippines as a priority region.",
        traction: "Prototype drone operational, 500 coral fragments planted in pilot, partnerships with 2 marine sanctuaries.",
        team: "Marine biologist PhD from UP Marine Science Institute with robotics engineer from MIT.",
        useOfFunds: "50% drone fleet development, 25% AI system, 15% coral propagation facility, 10% research.",
        riskDisclosure: "Deep-tech with longer path to commercialization. Underwater technology high maintenance costs.",
        milestones: [
            { title: "Prototype validation", status: "completed", amount: 500000 },
            { title: "Fleet of 5 drones", status: "pending", amount: 1500000 },
            { title: "AI mapping system", status: "pending", amount: 1000000 },
            { title: "Commercial restoration services", status: "pending", amount: 1500000 },
        ],
        updates: [],
        successFactors: [
            "Deep-tech innovation",
            "Partial verification",
            "Environmental urgency",
            "Research institution backing",
        ],
    },
    {
        id: "6985fd741c8b0a912817cc84",
        title: "Laro Studios: Filipino Indie Game Development",
        founder: "Mark Aquino",
        location: "BGC, Taguig, Philippines",
        category: "Creative",
        type: "donation",
        featured: false,
        verified: "partial",
        description: "A community game development studio providing workspace, equipment, mentorship, and publishing support for Filipino indie game creators. Our first game 'Diwata' features Philippine mythology.",
        raised: 420000,
        goal: 750000,
        backers: 312,
        daysLeft: 25,
        successPrediction: 68,
        equityOffered: null,
        riskLevel: "medium",
        image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=600&h=400&fit=crop",
        problem: "Filipino game developers lack affordable studio space, equipment, and publishing guidance to bring their games to market.",
        solution: "Community game studio with shared workspace, dev equipment, mentorship from industry veterans, and publishing support.",
        market: "₱200B global indie game market, 3M Filipino gamers, growing game dev community in Philippines.",
        traction: "'Diwata' demo has 50,000 downloads, community of 200 developers, 5 games in development pipeline.",
        team: "Former Ubisoft Singapore artist, with community organizers from game jam networks.",
        useOfFunds: "35% equipment & workspace, 25% game publishing pipeline, 25% developer stipends, 15% events.",
        riskDisclosure: "Game development timelines unpredictable, community engagement requires constant nurturing.",
        milestones: [
            { title: "Setup community studio", status: "completed", amount: 200000 },
            { title: "Launch 'Diwata' on Steam", status: "in-progress", amount: 200000 },
            { title: "Developer mentorship program", status: "pending", amount: 200000 },
            { title: "Annual game dev festival", status: "pending", amount: 150000 },
        ],
        updates: [],
        successFactors: [
            "Active developer community",
            "Partial verification",
            "Cultural representation",
            "Game demo traction",
        ],
    },
];

export const categories = [
    "All Categories",
    "Agriculture",
    "Health",
    "Environment",
    "Education",
    "Technology",
    "Fintech",
    "Food & Beverage",
    "Real Estate",
    "Creative",
    "Social Enterprise",
];

export const demoUsers = [
    {
        id: "founder-1",
        name: "Gershan Carl G. Bon",
        role: "Founder",
        email: "gershancarl.bon@demo.ph",
        description: "Create campaigns, track funding, manage milestones",
        avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face",
    },
    {
        id: "investor-1",
        name: "Gian S. Candelario",
        role: "Backer / Investor",
        email: "gian.candelario@demo.ph",
        description: "Browse campaigns, back projects, track portfolio",
        avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop&crop=face",
    },
    {
        id: "investor-2",
        name: "Joemrich Jovin N. Salcedo",
        role: "Backer / Investor",
        email: "joemrich.salcedo@demo.ph",
        description: "Discover social enterprises, invest in creative ventures",
        avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop&crop=face",
    },
    {
        id: "admin-1",
        name: "Eunel Angelo M. Guarte",
        role: "Platform Admin",
        email: "eunel.guarte@pitchpond.ph",
        description: "Verify founders, approve milestones, moderate content",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face",
    },
];

export const testimonials = [
    {
        name: "Gershan Carl G. Bon",
        role: "Founder & Entrepreneur",
        quote: "PitchPond gave me the platform to turn my vision into reality. The milestone-based escrow built trust with our backers and we hit our goal ahead of schedule.",
        avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face",
        rating: 5,
    },
    {
        name: "Gian S. Candelario",
        role: "Backer & Impact Investor",
        quote: "The AI success predictor and risk meter help me make smart, data-driven investment decisions. I've backed several campaigns and results have been outstanding.",
        avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=80&h=80&fit=crop&crop=face",
        rating: 5,
    },
    {
        name: "Joemrich Jovin N. Salcedo",
        role: "Backer & Social Enterprise Supporter",
        quote: "The transparency of PitchPond is unmatched. I can track exactly where my contributions go, and the founder updates keep me engaged every step of the way.",
        avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=80&h=80&fit=crop&crop=face",
        rating: 5,
    },
];

export default campaigns;
